// Credits:
// https://gomakethings.com/how-to-reorder-an-item-in-an-array-with-vanilla-js/

const changePosition = (arr, from, to) => {
  // Delete the item from it's current position
  const item = arr.splice(from, 1)

  // Move the item to its new position
  arr.splice(to, 0, item[0])

  return arr
}

export default changePosition
